import {
  useEffect,
  useCallback,
  type FC,
} from 'react';
import {
  useNavigate,
  useLocation,
} from 'react-router-dom';
import {
  Box,
  Stack,
  styled,
} from '@mui/joy';
import {
  successCheckMark
} from '../assets';
import {
  useWithdrawCoinsSuccessParams
} from '../lib';
import {
  TitleBlock
} from './title-block.component';
import {
  DetailsBlock
} from './details-block.component';
import {
  StartPlayingBlock
} from './start-playing-block.component';

const PageContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  paddingBlock: 40,
  paddingInline: 16,
  alignItems: 'center',
  height: 'fit-content',
  justifyContent: 'center',
  [theme.breakpoints.down(491)]: { padding: 16 }
}));

const PageContent = styled(Stack)(({ theme }) => ({
  gap: 16,
  padding: 12,
  width: '100%',
  maxWidth: 358,
  borderRadius: 8,
  height: 'fit-content',
  boxSizing: 'border-box',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common[475],
}));

export const WithdrawCoinsSuccessPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    hasDetails,
    checkoutDetails,
  } = useWithdrawCoinsSuccessParams();

  const handleStartPlaying = useCallback((): void => {
    navigate(location.state?.from || '/lobby', { replace: true })
  }, [location.state, navigate]);

  useEffect(() => {
    if (!hasDetails) handleStartPlaying();
  }, [hasDetails]);

  return (
    <PageContainer>
      <PageContent>
        <Box
          width={100}
          height={104}
          component='img'
          src={successCheckMark.default}
        />
        <TitleBlock />
        <DetailsBlock
          paymentId={checkoutDetails?.paymentId}
          accountNumber={checkoutDetails?.accountNumber}
          purchaseAmount={checkoutDetails.purchaseAmount}
        />
        <StartPlayingBlock onStartPlaying={handleStartPlaying} />
      </PageContent>
    </PageContainer>
  );
};